import {connect} from 'react-redux';

import ModelSelect from 'annuity_lab/tools/imo/components/model_select/model_select.js.jsx';

const mapStateToProps = ({imo}) => ({
    models: Object.values(imo.models)
});

export default connect(mapStateToProps)(ModelSelect);